import { INITIAL_USERS_REQUEST, FETCH_USERS_SUCCESS, FINAL_USERS_REQUEST } from "../../types/maintainers/users.type";

const initialState = {
	users: [],
	estates: [],
	areas: [],
	customers: [],
	roles: [],
	notifications: [],
	base_permissions: [],
	profiles: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_users(state = initialState, action) {
	switch (action.type) {
		case INITIAL_USERS_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_USERS_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				roles: action.payload.roles,
				profiles: action.payload.profiles,
				estates_parents: action.payload.estates_parents,
				estates: action.payload.estates,
				areas: action.payload.areas,
				notifications: action.payload.notifications,
				base_permissions: action.payload.base_permissions,
				users: action.payload.users,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		case FINAL_USERS_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		default:
			return state;
	}
}

export default maintainers_users;
